module.exports = __webpack_public_path__ + "fonts/rw-widgets-12f0820.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-widgets/dist/fonts/rw-widgets.woff?v=4.1.0
// module id = 225
// module chunks = 6